import { Outlet } from 'react-router';

import { Header } from '@/components/common';

const ErrorLayout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Header />
      <main className="flex items-center justify-center py-[80px] flex-1">
        <Outlet />
      </main>
    </div>
  );
};

export { ErrorLayout };
